export const ButtonActions = {
	SUBMIT: { caption: "Submit" },
	SEARCH: { caption: "Search" }
}
